import { navigateToUrl } from 'single-spa';

import { getEnvVar } from './getEnvVar';
import { getCookie, deleteCookie } from './cookies';

// inlined from @cloud/shared:
export const routes = {
    tenants: '/tenants', //             routes.tenants
    wizard: '/wizard', //               routes.wizard.index
    status: '/status', //               routes.statusPage
    instructions: '/instructions', //   routes.instructions
    quickStart: '/quick-start', //      routes.quickStart
    selectPlan: '/select-plan', //      routes.selectPlan
};

// This cookie is set one time on SSO product during Sign-UP.
// So when Cloud UI is loaded - we check if it exists,
// whick will mean that this is first Cloud visit after sign-up.
const SSO_ACCOUNT_COOKIE = 'sso_accountType';

const OMIT_REDIRECT_ROUTES = ['/', routes.wizard, routes.selectPlan];

/**
 * @param {boolean} isAdmin
 */
function getPostSignupRoute(isAdmin) {
    if (isAdmin) {
        return routes.wizard;
    }

    const isTrialsEnabled = getEnvVar('ENABLE_TRIAL_UI') === 'true';
    return isTrialsEnabled ? routes.selectPlan : routes.wizard;
}

/**
 * Determines the initial route for redirecting users from the root ('/').
 *
 * @param {{ isMember: boolean; isAdmin: boolean; aqaFlags: string }} params
 */
export function getRootRedirect({ isMember, isAdmin, aqaFlags }) {
    if (isMember) {
        return routes.instructions;
    }

    const isFirstVisitAfterSignup = Boolean(getCookie(SSO_ACCOUNT_COOKIE));

    if (!isFirstVisitAfterSignup) {
        return routes.status;
    }

    // Clear the cookie after reading it to ensure this redirect happens only once
    deleteCookie(SSO_ACCOUNT_COOKIE);

    // If AQA flag is present, override the redirect logic
    if (aqaFlags.includes('-onboarding-wizard')) {
        return isAdmin ? routes.status : routes.quickStart;
    }

    const signUpRedirect = getPostSignupRoute(isAdmin);

    // If the user is not on a root route, force a navigation
    if (!OMIT_REDIRECT_ROUTES.includes(window.location.pathname)) {
        navigateToUrl(signUpRedirect + window.location.search);
    }

    return signUpRedirect;
}
